var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cd-section",attrs:{"id":"pricing"}},[_c('Pricing1'),_c('Pricing2'),_c('Pricing3'),_c('Pricing4'),_c('Pricing5')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }